export const RESET_TIPPING_BARBERS = 'tipping/RESET_TIPPING_BARBERS';
export const SET_TIPPING_BARBERS = 'tipping/SET_TIPPING_BARBERS';
export const NEXT_TIPPING_BARBER = 'tipping/NEXT_TIPPING_BARBER';
export const PREVIOUS_TIPPING_BARBER = 'tipping/PREVIOUS_TIPPING_BARBER';
export const ASSIGN_TIP = 'tipping/ASSIGN_TIP';
export const TIPPING_DONE = 'tipping/DONE';
export const CANCEL_TIPPING = 'tipping/CANCEL';
export const SET_TIPS = 'tipping/SET_TIPS';
export const SET_PROCESSING = 'tipping/SET_PROCESSING';
export const SET_ADJUSTMENTS = 'tipping/SET_ADJUSTMENTS';
